// extracted by css-extract-rspack-plugin
export default {"slider":"xl58RJ","slider-short":"KxAheH","sliderShort":"KxAheH","slider-adoptables":"ALPdkD","sliderAdoptables":"ALPdkD","slider-item":"g1n93w","sliderItem":"g1n93w"};